import React from 'react'
import PropTypes from 'prop-types'
import SelectInput from '../../../../base/components/inputs/select-input/select-input'

const FontFamilySelect = ({ canvas, disabled, value, fonts, onChange }) => {
  const setFont = ({ name }) => {
    const selectedFont = (fonts.find((font) => font.name === name) || {})
    selectedFont.selected = true

    if (name === '') return

    const obj = canvas.getActiveObject()
    const currentTextIsBold = (obj.fontWeight === selectedFont.bold)
    const currentTextIsItalic = (obj.fontStyle === 'italic')
    const textIsBold = (!!selectedFont.bold && currentTextIsBold)
    const textIsItalic = (!!selectedFont.italic && currentTextIsItalic)
    const fontWeight = textIsBold ? selectedFont.bold : selectedFont.regular
    obj.exitEditing()
      .set('fontFamily', selectedFont.name)
      .set('fontWeight', fontWeight)
      .set('fontStyle', textIsItalic ? 'italic' : 'normal')
    obj._supportsBold = !!selectedFont.bold
    obj._supportsItalic = selectedFont.italic
    canvas.renderAll()

    onChange && onChange({
      selectedFont,
      textSupportsBold: !!selectedFont.bold,
      textSupportsItalic: selectedFont.italic,
    })
  }

  const getFontFamilyProps = () => {
    const options = fonts.map(({ name }) => {
      return { name }
    })

    const defaultProps = {
      value,
      options,
      name: 'fontFamily',
      containerClass: 'fontFamilySelect',
      allowCreate: false,
      notAsync: true,
      disabled,
      handleChange: setFont,
      customSelectOptions: {
        placeholder: 'Wähle Schriftart',
        labelKey: 'name',
        valueKey: 'name',
        clearable: false,
        backspaceRemoves: false,
        formatOptionLabel: (option) => {
          return <div style={{ fontFamily: option.name }}>{option.name}</div>
        },
      },
    }

    // hide menu if text gets deselected
    if (disabled) {
      Object.assign(defaultProps.customSelectOptions, { menuIsOpen: false })
    }

    return defaultProps
  }

  const fontSelectProps = getFontFamilyProps()

  return (
    <div className='letterHeaderTools_fontFamily'>
      <SelectInput {...fontSelectProps} />
    </div>
  )
}

FontFamilySelect.propTypes = {
  canvas: PropTypes.object,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  fonts: PropTypes.array,
}

export default FontFamilySelect
